package one.devsbox.www.ui.resources.detail

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import compose.assets.Svg
import compose.assets.svg.DeleteOutline
import compose.assets.svg.DownloadOutline
import kotlinx.browser.window
import kotlinx.coroutines.launch
import kotlinx.datetime.LocalDateTime
import one.devsbox.commons.EMPTY
import one.devsbox.shared.ads.SharedIO
import one.devsbox.shared.files.ResourceType
import one.devsbox.www.io.Repository
import one.devsbox.www.ui.widgets.ScreenContentAction
import one.devsbox.www.www_portal.generated.resources.*
import tk.mallumo.compose.navigation.viewmodel.NavigationViewModel
import tk.mallumo.compose.navigation.viewmodel.VM
import tk.mallumo.utils.DataState

@VM
class ResourceVM : NavigationViewModel() {
    private lateinit var ctx: ResourceCtx

    var contentActions by mutableStateOf<List<ScreenContentAction>>(emptyList())
        private set

    var showDeleteConfirmation by mutableStateOf(false)
        private set

    var state by mutableStateOf<DataState<SharedIO.Media>>(DataState.Loading())
        private set

    interface Action {
        fun reload()
        fun back()

        fun download()
        fun delete()
        fun confirmDelete()
        fun dismissDeleteConfirmation()
    }

    val action = object : Action {
        override fun reload() {
            loadMedia(ctx.args.id)
        }

        override fun back() {
            ctx.nav.up()
        }

        override fun download() {
            val media = state.entry ?: return
            val url = when (ResourceType[media.type]) {
                ResourceType.VIDEO -> Repository.createUrlVideo(media.id)
                ResourceType.IMAGE -> Repository.createUrlImage(media.id)
                else -> return
            }
            window.open(url, "_blank")
        }

        override fun delete() {
            showDeleteConfirmation = true
        }

        override fun dismissDeleteConfirmation() {
            showDeleteConfirmation = false
        }

        override fun confirmDelete() {
            showDeleteConfirmation = false
            val currentMedia = state.entry ?: return
            state = DataState.Loading(currentMedia)
            scope.launch {
                runCatching {
                    Repository.ads.media.delete(ctx.args.id)
                }.onSuccess {
                    ctx.nav.up()
                }.onFailure {
                    state = DataState.Error(it.message ?: "Failed to delete media")
                    setupActions(currentMedia)
                }
            }
        }
    }

    fun setup(ctx: ResourceCtx) {
        this.ctx = ctx
        if (state is DataState.Loading) {
            loadMedia(ctx.args.id)
        }
    }

    private fun loadMedia(id: Long) {
        state = DataState.Loading()
        scope.launch {
            runCatching {
                Repository.ads.media.get(id)
            }.onSuccess {
                state = DataState.Result(it)
                setupActions(it)
            }.onFailure {
                state = DataState.Error(it.message ?: "Unknown error")
                contentActions = emptyList()
            }
        }
    }

    private fun setupActions(media: SharedIO.Media) {
        contentActions = buildList {
            if (media.readyDT != LocalDateTime.EMPTY) {
                add(
                    ScreenContentAction(
                        text = Res.string.ui_resources_detail_btn_download,
                        color = ctx.colorPrimaryContainer,
                        icon = Svg.DownloadOutline
                    ) {
                        action.download()
                    }
                )
            }
            if (ctx.me.permission.media.delete && !ctx.me.info.adminMode) {
                add(
                    ScreenContentAction(
                        text = Res.string.ui_resources_detail_btn_delete,
                        color = ctx.colorErrorContainer,
                        icon = Svg.DeleteOutline
                    ) {
                        action.delete()
                    }
                )
            }
        }
    }

    override fun onRelease() {}
}